<template>
  <div class="page-wrapper">
    <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount !== 0"
         style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="request-container">
        <div class="cabinet">
          <div class="cabinet-head visibility">
            <div class="title">Все заявки</div>
          </div>
          <div class="cabinet-body">
            <div class="cabinet-sidebar">
              <div class="form">
                <div class="sidebar-title">Поиск заявок</div>
                <div class="filter-body">
                  <div class="fieldset date-select">
                    <label class="fieldset-title">Период</label>
                    <fieldset>
                      <date-picker
                              v-model="dateFilterFrom"
                              format="DD.MM.YYYY"
                              lang="ru"
                              v-mask="'##.##.####'"
                              placeholder="__.__.____"
                              ref="datePickerFrom"
                              :clearable="false"
                              :first-day-of-week="1"
                              @panel-change="changePanelDatePickerFrom"
                              @input="checkFirstDateOrder(dateFilterFrom)">
                      </date-picker>
                      -
                      <date-picker
                              v-model="dateFilterTo"
                              format="DD.MM.YYYY"
                              lang="ru"
                              v-mask="'##.##.####'"
                              placeholder="__.__.____"
                              ref="datePickerTo"
                              :clearable="false"
                              :first-day-of-week="1"
                              @panel-change="changePanelDatePickerTo"
                              @input="checkSecondDateOrder(dateFilterTo)">
                      </date-picker>
                    </fieldset>
                  </div>
                  <div class="fieldset">
                    <label class="fieldset-title">Имя, отчество или организация</label>
                    <fieldset><input type="text" v-model="clientNameOrOrgNameFilter" @input="makeFilterBtnsVisible">
                    </fieldset>
                  </div>
                  <div class="fieldset">
                    <label class="fieldset-title">Номер телефона</label>
                    <fieldset><input type="text" v-model="clientPhoneFilter" @input="makeFilterBtnsVisible"></fieldset>
                  </div>
                  <div class="fieldset">
                    <label class="fieldset-title">Статус</label>

                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabOkStatus">Принята</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabWaitStatus">Ожидает</label>
                    </div>
                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabNotOkStatus">Отклонена</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabInWorkStatus">Распределена</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                            type="checkbox" v-model="hasThisTabWorkersConfirmed">Рабочие подтверждены</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                            type="checkbox" v-model="hasThisTabStarted">Начали</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                            type="checkbox" v-model="hasThisTabPredictionReceived">Прогноз получен</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabWaitToPaymentStatus">Подтвердить
                      оплату</label></div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabEndStatus">Завершена</label>
                    </div>
                  </div>
                  <div class=" fieldset">
                    <label class="fieldset-title">Услуги</label>
                    <fieldset>
                      <select v-model="serviceFilter" @input="makeFilterBtnsVisible">
                        <option disabled :value="null">-- Выбрать --</option>
                        <option value="OrderToTrucking">Грузоперевозки</option>
                        <option value="OrderToMover">Грузчики</option>
                        <option value="OrderToFurniture">Сборка мебели</option>
                        <option value="OrderToPetrol">ГСМ</option>
                        <option value="OrderToDowntime">Сутки простоя</option>
                        <option value="OrderToGarbage">Вывоз мусора</option>
                        <option value="OrderToAdditional">Доп. услуги</option>
                      </select>
                    </fieldset>
                  </div>
                  <div class="fieldset">
                    <label class="fieldset-title">Тип расчёта</label>

                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabCashType">Наличный</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabNotCashType">Безналичный</label>
                    </div>
                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabCheckType">По чеку</label>
                    </div>
                  </div>
                  <div class="fieldset">
                    <label class="fieldset-title">Акция</label>

                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabNoneFlyerStatus">Без акции</label>
                    </div>
                    <div class=" checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabActiveFlyerStatus">Акция не подтверждена</label>
                    </div>
                    <div class="checkbox"><label class="checkbox-label"><input
                        type="checkbox" v-model="hasThisTabConfirmedFlyerStatus">Акция подтверждена</label>
                    </div>
                  </div>
                  <div class="form-filter-button" :class="{'filter-button-view': areFilterBtnsVisible}">
                    <button type="button" @click="filterOrders">Найти</button>
                    <div class="clear-filter">
                      <span class="clear-filter-button" @click="clearFilterPanelAndFilteredData"><img
                          src="../image/clear-filter.svg">Очистить фильтр</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filter-button" :class="{'filter-button-view': areFilterBtnsVisible}">
                <button type="button" @click="filterOrders">Найти</button>
                <div class="clear-filter">
                  <span class="clear-filter-button" @click="clearFilterPanelAndFilteredData"><img
                      src="../image/clear-filter.svg">Очистить фильтр</span>
                </div>
              </div>
            </div>
            <div class="cabinet-info page-scroll" @scroll="onContentScroll" ref="cabinetInfo">
              <div class="all-request-tabs">
                <ul class="tabs">
                  <li :class="{active: tabNum === 0}" data-page="0" @click="changeTab(0)">Заказы</li>
                  <li :class="{active: tabNum === 1}" data-page="1" @click="changeTab(1)">Звонки</li>
                  <li :class="{active: tabNum === 2}" data-page="2" @click="changeTab(2)">Завершенные
                    заказы
                  </li>
                  <li :class="{active: tabNum === 3}" data-page="3" @click="changeTab(3)">Поиск</li>
                </ul>
                <div>
                  <div class="requests-list" v-if="tabNum !== 3">
                    <router-link :to="{ name: 'Order', params: { id: order.id } }"
                                 @click.native="updateAllOrdersFilter"
                                 v-for="(order, index) in thisTabOrders"
                                 v-if="index < selectionNr" class="item">
                      <div class="item-head visibility">
                        <div class="request-id">Заявка {{order.id}}</div>
                        <div class="date">{{order.date}} {{order.time}}</div>
                        <div class="comment" v-if="order.comment && order.comment.length > 0">
                          <span class="icon fa fa-comment"></span>
                          <span class="text">{{ order.comment }}</span>
                        </div>
                        <div class="status">
                          <span class="active-status green-status" v-if="order.status == 0">Принята</span>
                          <span class="active-status yellow-status" v-else-if="order.status == 1">Ожидает</span>
                          <span class="active-status red-status" v-else-if="order.status == 2">Отклонена</span>
                          <span class="active-status light-blue-status"
                                v-else-if="order.status == 3">Распределена</span>
                          <span class="active-status rose-status"
                                v-else-if="order.status == 4">Подтвердить оплату</span>
                          <span class="active-status blue-status" v-else-if="order.status == 5">Завершена</span>
                          <span class="active-status orange-status" v-else-if="order.status == 6">Рабочие подтверждены</span>
                          <span class="active-status violet-status" v-else-if="order.status == 7">Начали</span>
                          <span class="active-status brown-status" v-else-if="order.status == 8">Прогноз получен</span>
                        </div>
                      </div>
                      <div class="item-client">
                        <div class="icon"><img src="../image/client.svg"></div>
                        <div class="name">{{order.clientName}} <span
                            v-if="order.clientOrg" class="firm">({{order.clientOrgName}})</span>
                        </div>
                        <div class="tel">{{order.clientPhone}}</div>
                      </div>
                      <div class="item-description">
                        <div class="address">
                          <div class="icon"><img src="../image/route.svg"></div>
                          {{order.address}}
                        </div>
                        <div class="items">
                          <div class="icon"><img src="../image/item.svg"
                                                 v-show="getOrdersCategoriesString(order.services).length"></div>
                          {{getOrdersCategoriesString(order.services)}}
                        </div>
                        <div class="total">{{order.summaryPrice}} <span class="rub">руб.</span></div>
                      </div>
                    </router-link>
                  </div>

                  <div class="requests-list" v-if="tabNum === 3">
                    <router-link :to="{ name: 'Order', params: { id: order.id } }"
                                 @click.native="updateAllOrdersFilter"
                                 v-for="(order, index) in filteredOrders"
                                 v-if="index < selectionNr" class="item">
                      <div class="item-head visibility">
                        <div class="request-id">Заявка {{order.id}}</div>
                        <div class="date">{{order.date}} {{order.time}}</div>
                        <div class="comment" v-if="order.comment && order.comment.length > 0">
                          <span class="icon fa fa-comment"></span>
                          <span class="text">{{ order.comment }}</span>
                        </div>
                        <div class="status">
                          <span class="active-status green-status" v-if="order.status == 0">Принята</span>
                          <span class="active-status yellow-status" v-else-if="order.status == 1">Ожидает</span>
                          <span class="active-status red-status" v-else-if="order.status == 2">Отклонена</span>
                          <span class="active-status light-blue-status"
                                v-else-if="order.status == 3">Распределена</span>
                          <span class="active-status rose-status"
                                v-else-if="order.status == 4">Подтвердить оплату</span>
                          <span class="active-status blue-status" v-else-if="order.status == 5">Завершена</span>
                          <span class="active-status orange-status"
                                v-else-if="order.status == 6">Рабочие подтверждены</span>
                          <span class="active-status violet-status"
                                v-else-if="order.status == 7">Начали</span>
                          <span class="active-status brown-status"
                                v-else-if="order.status == 8">Прогноз получен</span>
                        </div>
                      </div>
                      <div class="item-client">
                        <div class="icon"><img src="../image/client.svg"></div>
                        <div class="name">{{order.clientName}} <span v-if="order.clientOrgName != null"
                                                                     class="firm">({{order.clientOrgName}})</span>
                        </div>
                        <div class="tel">{{order.clientPhone}}</div>
                      </div>
                      <div class="item-description">
                        <div class="address">
                          <div class="icon"><img src="../image/route.svg"></div>
                          {{order.address}}
                        </div>
                        <div class="items">
                          <div class="icon"><img src="../image/item.svg"
                                                 v-show="getOrdersCategoriesString(order.services).length"></div>
                          {{getOrdersCategoriesString(order.services)}}
                        </div>
                        <div class="total">{{order.summaryPrice}} <span class="rub">руб.</span></div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuDispatcher from '@/components/MenuDispatcher'
  import HeaderDispatcher from '@/components/HeaderDispatcher'
  import moment from 'moment'
  import DatePicker from 'vue2-datepicker'
  import {mask} from 'vue-the-mask'
  import api from '@/api'
  import utils from '@/utils'

  export default {
    name: 'AllOrders',
    components: {
      MenuDispatcher,
      HeaderDispatcher,
      DatePicker
    },

    directives: {mask},

    data() {
      return {
        clientNameOrOrgNameFilter: '',
        clientPhoneFilter: '',
        dateFilterFrom: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).valueOf(),
        dateFilterTo: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).valueOf() - 1,
        statusesInThisTab: [],
        statusesFilter: [],
        cashTypesFilter: [],
        flyerFilter: [],
        serviceFilter: null,
        tabNum: 0,
        orders: [],
        filteredOrders: [],
        areFilterBtnsVisible: false,
        selectionNr: 10,
        firstTabStatuses: [0, 3, 4, 6, 7, 8],
        secondTabStatuses: [1, 2],
        thirdTabStatuses: [5],
        tabCashTypes: [0, 1, 2],
        tabFlyerStatuses: ['none', 'active', 'confirmed'],

        filterPanelStore: {
          clientNameOrOrgNameFilter: '',
          clientPhoneFilter: '',
          dateFilterFrom: null,
          dateFilterTo: null,
          statusesFilter: [],
          serviceFilter: null,
          cashTypesFilter: [],
          tabFlyerStatuses: []
        }
      }
    },

    computed: {
      waitingApiRequestsCount() {
        return this.$store.getters.waitingApiRequestsCount
      },

      thisTabOrders() {
        return this.orders.filter(order => {
          return this.statusesInThisTab.indexOf(order.status) > -1 &&
              order.dateAndTime >= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).valueOf() &&
              order.dateAndTime <= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).valueOf() - 1
        })
      },

      hasThisTabOkStatus: {
        get() {
          return this.statusesFilter.indexOf(0) > -1
        },

        set() {
          this.editStatusFilter(0)
        }
      },

      hasThisTabWaitStatus: {
        get() {
          return this.statusesFilter.indexOf(1) > -1
        },

        set() {
          this.editStatusFilter(1)
        }
      },

      hasThisTabNotOkStatus: {
        get() {
          return this.statusesFilter.indexOf(2) > -1
        },

        set() {
          this.editStatusFilter(2)
        }
      },

      hasThisTabInWorkStatus: {
        get() {
          return this.statusesFilter.indexOf(3) > -1
        },

        set() {
          this.editStatusFilter(3)
        }
      },

      hasThisTabWorkersConfirmed: {
        get() {
          return this.statusesFilter.indexOf(6) > -1
        },

        set() {
          this.editStatusFilter(6)
        }
      },

      hasThisTabStarted: {
        get() {
          return this.statusesFilter.indexOf(7) > -1
        },

        set() {
          this.editStatusFilter(7)
        }
      },

      hasThisTabPredictionReceived: {
        get() {
          return this.statusesFilter.indexOf(8) > -1
        },

        set() {
          this.editStatusFilter(8)
        }
      },

      hasThisTabWaitToPaymentStatus: {
        get() {
          return this.statusesFilter.indexOf(4) > -1
        },

        set() {
          this.editStatusFilter(4)
        }
      },

      hasThisTabEndStatus: {
        get() {
          return this.statusesFilter.indexOf(5) > -1
        },

        set() {
          this.editStatusFilter(5)
        }
      },

      hasThisTabCashType: {
        get() {
          return this.cashTypesFilter.includes(0)
        },
        set() {
          this.editCashTypesFilter(0)
        }
      },

      hasThisTabNotCashType: {
        get() {
          return this.cashTypesFilter.includes(1)
        },
        set() {
          this.editCashTypesFilter(1)
        }
      },

      hasThisTabCheckType: {
        get() {
          return this.cashTypesFilter.includes(2)
        },
        set() {
          this.editCashTypesFilter(2)
        }
      },

      hasThisTabNoneFlyerStatus: {
        get() {
          return this.flyerFilter.includes('none')
        },
        set() {
          this.editFlyerFilter('none')
        }
      },
      hasThisTabActiveFlyerStatus: {
        get() {
          return this.flyerFilter.includes('active')
        },
        set() {
          this.editFlyerFilter('active')
        }
      },
      hasThisTabConfirmedFlyerStatus: {
        get() {
          return this.flyerFilter.includes('confirmed')
        },
        set() {
          this.editFlyerFilter('confirmed')
        }
      }
    },

    methods: {
      changePanelDatePickerFrom(panel) {
        if (panel !== 'NONE') {
          this.$refs.datePickerTo.popupVisible = false;
          this.makeFilterBtnsVisible();
        }
      },

      changePanelDatePickerTo(panel) {
        if (panel !== 'NONE') {
          this.$refs.datePickerFrom.popupVisible = false;
          this.makeFilterBtnsVisible();
        }
      },

      filterOrders() {
        this.tabNum = 3
        this.selectionNr = 10

        let filteredByDateOrders = []
        api
            .getAllOrders(this.dateFilterFrom.valueOf(), this.dateFilterTo.valueOf())
            .then(orders => {
              if (orders) {
                filteredByDateOrders = orders
                filteredByDateOrders.forEach(order => this.formatDateAndTime(order))
              }
              return filteredByDateOrders
            })
            .then(orders => {
              filteredByDateOrders = filteredByDateOrders
                  .filter(order => this.statusesFilter.indexOf(order.status) > -1)
                  .filter(order =>
                      (this.hasThisTabCashType && !!order.cash && !order.check)
                      || (this.hasThisTabNotCashType && !order.cash)
                      || (this.hasThisTabCheckType && !!order.check)
                  )
                  .filter(order =>
                      this.flyerFilter.indexOf(order.flyerStatus) != -1)
                  .filter(order => {
                      let clientNameOrOrgNameFilter = this.clientNameOrOrgNameFilter.toLowerCase().trim();
                      if (!clientNameOrOrgNameFilter)
                        return true;
                      clientNameOrOrgNameFilter = clientNameOrOrgNameFilter
                              .split(' ').map(f => f.trim()).filter(f => f).join(' ');

                      return (order.clientName.toLowerCase().trim().indexOf(clientNameOrOrgNameFilter) != -1)
                          || (order.clientOrgName && order.clientOrgName.toLowerCase().trim().indexOf(clientNameOrOrgNameFilter) != -1)
                          || order.services.filter(s => {
                            if (!s.worker.id)
                              return false;

                            let wName = s.worker.name.toLowerCase().trim();
                            let wPatronymic = s.worker.patronymic.toLowerCase().trim();
                            let filterPartCount = clientNameOrOrgNameFilter.split(' ').length;

                            return (filterPartCount > 1
                                && wPatronymic.split(' ')
                                        .map(p => p.trim())
                                        .filter(p => p)
                                        .filter(p => {
                                          // Т.к. в отчество работников заказчик прописывает данные банковской карты рабочего,
                                          // и отчество может выглядеть как "Михайлович (карта СБ) 123456789",
                                          // ищем совпадения по "Иван Михайлович" и "Иван 123456789"
                                          return clientNameOrOrgNameFilter.indexOf(wName + ' ' + p) != -1
                                              || clientNameOrOrgNameFilter.indexOf(p + ' ' + wName) != -1
                                        }).length > 0)
                                || (filterPartCount == 1
                                    && (wName.indexOf(clientNameOrOrgNameFilter) != -1
                                        || wPatronymic.indexOf(clientNameOrOrgNameFilter) != -1));
                          }).length > 0;
                  })
                  .filter(order => {
                      let clientPhoneFilter = this.clientPhoneFilter.toLowerCase().trim();
                      if (!clientPhoneFilter)
                        return true;
                    clientPhoneFilter = clientPhoneFilter
                        .split(' ').map(f => f.trim()).filter(f => f).join(' ');

                      return order.clientPhone.toLowerCase().trim().indexOf(clientPhoneFilter) != -1
                          || order.services.filter(s => {
                            if (!s.worker.id)
                              return false;

                            return s.worker.phone.toLowerCase().trim().indexOf(clientPhoneFilter) != -1;
                          }).length > 0;
                  })
                  .filter(order => this.filterByService(order.services))
              this.filteredOrders = []
              this.filteredOrders = filteredByDateOrders
            })
            .then(() => {
              this.filterPanelStore =
                  {
                    clientNameOrOrgNameFilter: this.clientNameOrOrgNameFilter,
                    clientPhoneFilter: this.clientPhoneFilter,
                    dateFilterFrom: this.dateFilterFrom,
                    dateFilterTo: this.dateFilterTo,
                    statusesFilter: this.statusesFilter,
                    serviceFilter: this.serviceFilter,
                    cashTypesFilter: this.cashTypesFilter,
                    flyerFilter: this.flyerFilter
                  }
            })
      },

      formatDateAndTime(order) {
        order.date = moment(String(new Date(order.dateAndTime))).format('DD.MM.YYYY')
        order.time = moment(String(new Date(order.dateAndTime))).format('HH:mm')
      },

      checkFirstDateOrder(value) {
        if (value > this.dateFilterTo) {
          let newDateTo = new Date(this.dateFilterFrom)
          newDateTo.setHours(23, 59, 59, 0)
          // костыль, так как замапить на this.dateFilterTo и запустить ререндер нельзя ->
          // в таком случае отвалится вотчер
          this.$refs.datePickerTo.userInput = moment(newDateTo).format('DD.MM.YYYY')
        }
      },

      checkSecondDateOrder(value) {
        if (value < this.dateFilterFrom) {
          let newDateFrom = new Date(this.dateFilterTo)
          newDateFrom.setHours(0, 0, 0, 0)
          // костыль, так как замапить на this.dateFilterTo и запустить ререндер нельзя ->
          // в таком случае отвалится вотчер
          this.$refs.datePickerFrom.userInput = moment(newDateFrom).format('DD.MM.YYYY')
        }
      },

      filterByService(services) {
        if (this.serviceFilter != null) {
          if (services.length === 0) {
            return false
          }

          for (let service of services) {
            if (service.type === this.serviceFilter) {
              return true
            }
          }
          return false
        } else {
          return true
        }
      },

      makeFilterBtnsVisible() {
        this.areFilterBtnsVisible = true
      },

      makeFilterBtnsUnvisible() {
        this.areFilterBtnsVisible = false
      },

      clearFilterPanelAndFilteredData() {
        let date = new Date()

        this.filteredOrders = []

        this.filterPanelStore.clientNameOrOrgNameFilter = ''
        this.filterPanelStore.clientPhoneFilter = ''
        this.filterPanelStore.dateFilterFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate()).valueOf()
        this.filterPanelStore.dateFilterTo = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).valueOf() - 1
        this.filterPanelStore.statusesFilter = []
        this.filterPanelStore.serviceFilter = null
        this.filterPanelStore.cashTypesFilter = []
        this.filterPanelStore.flyerFilter = []

        this.clearFilter()
      },

      clearFilter() {
        let date = new Date()

        this.clientNameOrOrgNameFilter = ''
        this.clientPhoneFilter = ''
        this.dateFilterFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate()).valueOf()
        this.dateFilterTo = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).valueOf() - 1
        this.statusesFilter = []
        this.cashTypesFilter = []
        this.flyerFilter = []
        this.spotStatusesInThisTab()
        this.spotCashTypesInThisTab()
        this.spotFlyerStatusesInThisTab()
        this.serviceFilter = null
        this.makeFilterBtnsUnvisible()
      },

      changeTab(newTabNum) {
        if (this.tabNum === 3) {
          this.clearFilter()
        }

        this.tabNum = newTabNum
        this.statusesInThisTab = []
        this.statusesFilter = []
        this.cashTypesFilter = []
        this.flyerFilter = []
        this.makeFilterBtnsUnvisible()
        this.selectionNr = 10

        if (newTabNum === 0) {
          this.statusesInThisTab = this.firstTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
          this.cashTypesFilter = this.tabCashTypes;
          this.flyerFilter = this.tabFlyerStatuses;
        }
        if (newTabNum === 1) {
          this.statusesInThisTab = this.secondTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
          this.cashTypesFilter = this.tabCashTypes;
          this.flyerFilter = this.tabFlyerStatuses;
        }
        if (newTabNum === 2) {
          this.statusesInThisTab = this.thirdTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
          this.cashTypesFilter = this.tabCashTypes;
          this.flyerFilter = this.tabFlyerStatuses;
        }
        if (newTabNum === 3) {
          this.fullFiltersFromFilterPanelStore()
          this.makeFilterBtnsVisible()

          if (this.filteredOrders.length === 0) {
            this.filterOrders()
          }
        }
      },

      fullFiltersFromFilterPanelStore() {
        this.clientNameOrOrgNameFilter = this.filterPanelStore.clientNameOrOrgNameFilter
        this.clientPhoneFilter = this.filterPanelStore.clientPhoneFilter
        this.dateFilterFrom = this.filterPanelStore.dateFilterFrom
        this.dateFilterTo = this.filterPanelStore.dateFilterTo
        this.statusesFilter = this.filterPanelStore.statusesFilter
        this.cashTypesFilter = this.filterPanelStore.cashTypesFilter
        this.flyerFilter = this.filterPanelStore.flyerFilter
        this.serviceFilter = this.filterPanelStore.serviceFilter
      },

      spotStatusesInThisTab() {
        if (this.tabNum === 0) {
          this.statusesInThisTab = this.firstTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
        }
        if (this.tabNum === 1) {
          this.statusesInThisTab = this.secondTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
        }
        if (this.tabNum === 2) {
          this.statusesInThisTab = this.thirdTabStatuses
          this.statusesFilter = this.statusesInThisTab.slice()
        }
        if (this.tabNum === 3) {
          this.statusesInThisTab = []
          this.statusesFilter = this.statusesInThisTab.slice()
        }
      },

      spotCashTypesInThisTab() {
        if (this.tabNum !== 3)
          this.cashTypesFilter = this.tabCashTypes;
        else
          this.cashTypesFilter = [];
      },

      spotFlyerStatusesInThisTab() {
        this.flyerFilter = this.tabFlyerStatuses;
      },

      editStatusFilter(statusNum) {
        this.makeFilterBtnsVisible()

        let indexOfStatus = this.statusesFilter.indexOf(statusNum)
        if (indexOfStatus === -1) {
          this.statusesFilter.push(statusNum)
        } else {
          this.statusesFilter.splice(indexOfStatus, 1)
        }
      },

      editCashTypesFilter(statusNum) {
        this.makeFilterBtnsVisible()

        let indexOfStatus = this.cashTypesFilter.indexOf(statusNum)
        if (indexOfStatus === -1) {
          this.cashTypesFilter.push(statusNum)
        } else {
          this.cashTypesFilter.splice(indexOfStatus, 1)
        }
      },

      editFlyerFilter(flyerStatus) {
        this.makeFilterBtnsVisible()

        let indexOfStatus = this.flyerFilter.indexOf(flyerStatus)
        if (indexOfStatus === -1) {
          this.flyerFilter.push(flyerStatus)
        } else {
          this.flyerFilter.splice(indexOfStatus, 1)
        }
      },

      updateOrdersListByScrollDown() {
        let listLength = this.thisTabOrders.length
        if (this.filteredOrders && this.filteredOrders.length !== 0) {
          listLength = this.filteredOrders.length
        }
        if (listLength > this.selectionNr &&
            (this.$refs.cabinetInfo.firstElementChild.clientHeight - this.$refs.cabinetInfo.offsetHeight <= this.$refs.cabinetInfo.scrollTop)) {
          this.selectionNr += 10
        }
      },

      getOrdersCategoriesString(services) {
        let resultStr = ''
        let tabuList = []
        let counter = 0
        let categoryName = ''

        for (let service of services) {
          categoryName = service.category.name

          if (tabuList.indexOf(categoryName) === -1) {
            counter = 0

            services.forEach(s => {
              if (s.category.name === categoryName) {
                counter++
              }
            })

            tabuList.push(categoryName)
            resultStr += categoryName + ' (' + counter + ' шт.), '
          }
        }
        return resultStr.substr(0, resultStr.length - 2)
      },

      onContentScroll() {
        this.updateOrdersListByScrollDown()
      },

      initFilter() {
        let filter = this.$store.getters.allOrdersFilter

        this.filterPanelStore.clientNameOrOrgNameFilter = filter.clientNameOrOrgNameFilter
        this.filterPanelStore.clientPhoneFilter = filter.clientPhoneFilter
        this.filterPanelStore.dateFilterFrom = filter.dateFilterFrom
        this.filterPanelStore.dateFilterTo = filter.dateFilterTo
        this.filterPanelStore.statusesFilter = filter.statusesFilter
        this.filterPanelStore.cashTypesFilter = filter.cashTypesFilter
        this.filterPanelStore.flyerFilter = filter.flyerFilter
        this.filterPanelStore.serviceFilter = filter.serviceFilter

        this.tabNum = filter.tabNum
        if (this.tabNum === 3) {
          this.fullFiltersFromFilterPanelStore()
          this.filterOrders()
          this.areFilterBtnsVisible = true
        } else {
          this.spotStatusesInThisTab()
          this.spotCashTypesInThisTab()
          this.spotFlyerStatusesInThisTab()
        }
      },

      updateAllOrdersFilter() {
        this.$store.commit('updateAllOrdersFilter', {
          clientNameOrOrgNameFilter: this.filterPanelStore.clientNameOrOrgNameFilter,
          clientPhoneFilter: this.filterPanelStore.clientPhoneFilter,
          dateFilterFrom: this.filterPanelStore.dateFilterFrom.valueOf(),
          dateFilterTo: this.filterPanelStore.dateFilterTo.valueOf(),
          statusesFilter: this.filterPanelStore.statusesFilter,
          serviceFilter: this.filterPanelStore.serviceFilter,
          cashTypesFilter: this.filterPanelStore.cashTypesFilter,
          flyerFilter: this.filterPanelStore.flyerFilter,
          tabNum: this.tabNum
        })
      },

      addDatePickerWatchers() {
        // нужны для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

        this.$watch(
          () => {
            return this.$refs.datePickerFrom.userInput
          },
          (newVal, oldVal) => {
            let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
            if (tmpValueForDatePicker) {
              this.dateFilterFrom = tmpValueForDatePicker;
              this.$refs.datePickerFrom.popupVisible = false;
              this.checkFirstDateOrder(this.dateFilterFrom);
            } else if (tmpValueForDatePicker === null) {
              this.$refs.datePickerFrom.userInput = '';
              this.$refs.datePickerFrom.currentValue = null;
            }
          }
        );

        this.$watch(
          () => {
            return this.$refs.datePickerTo.userInput
          },
          (newVal, oldVal) => {
            let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
            if (tmpValueForDatePicker) {
              this.dateFilterTo = tmpValueForDatePicker;
              this.$refs.datePickerTo.popupVisible = false;
              this.checkSecondDateOrder(this.dateFilterTo);
            } else if (tmpValueForDatePicker === null) {
              this.$refs.datePickerTo.userInput = '';
              this.$refs.datePickerTo.currentValue = null;
            }
          }
        );
      }
    },

    mounted() {
      this.initFilter()
      this.addDatePickerWatchers();

      api
          .getAllOrders(this.dateFilterFrom, this.dateFilterTo)
          .then(orders => {
            if (orders) {
              this.orders = []
              this.orders = orders
              this.orders.forEach(order => this.formatDateAndTime(order))
            }
          })

      let body = document.getElementsByTagName('body')[0]
      body.classList.add('cabinet-page')
      // this.statusesFilter = this.statusesFilter.concat(this.statusesInThisTab)
      // this.cashTypesFilter = this.cashTypesFilter.concat(this.tabCashTypes)
    },

    destroyed() {
      let body = document.getElementsByTagName('body')[0]
      body.classList.remove('cabinet-page')
    }
  }
</script>
